export default __webpack_public_path__ + "static/media/home_message_icon.f52558cc.png";